var map = {
	"./de/gotoTOPbg.png": "pn6v",
	"./en/gotoTOPbg.png": "j8zV",
	"./es/gotoTOPbg.png": "/vUU",
	"./fr/gotoTOPbg.png": "CHWG",
	"./ja/gotoTOPbg.png": "nZ1Q",
	"./ko/gotoTOPbg.png": "QLXD",
	"./pt/gotoTOPbg.png": "4jrx",
	"./ru/gotoTOPbg.png": "m26t",
	"./tc/gotoTOPbg.png": "ZNiP",
	"./th/gotoTOPbg.png": "oreJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OytO";